const IdaasContent = (): JSX.Element => {
  return <div></div>;
};

export default IdaasContent;
